import React, { useState } from "react";
import PropTypes from "prop-types";
import { loadStripe } from "@stripe/stripe-js/pure";
import { LinearProgress } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import StripeCheckout from "./StripeCheckout";
import ErrorScreen from "core/components/ErrorScreen";
import { useTheme } from "@mui/material/styles";

export default function StripePaymentForm({
  paymentData,
  returnUrl,
  setError,
  recurrentDescComponent,
  paymentHasError,
  setPaymentHasError,
}) {
  const [loading, setLoading] = useState(true);
  const theme = useTheme();

  if (!paymentData.publishableKey) {
    return <ErrorScreen title="Publishable Key Not Found" />;
  }

  const stripePromise = loadStripe(paymentData.publishableKey)
    .then((stripe) => {
      return stripe;
    })
    .catch((err) => {
      setError(err);
    });

  const options = {
    clientSecret: paymentData.clientSecret,
    appearance: {
      theme: "stripe",
      variables: {
        colorPrimary: theme.palette.primary.main,
        colorBackground: theme.palette.background.body,
        colorText: theme.palette.text.primaryInHex,
        colorDanger: theme.palette.error.dark,
        fontFamily: theme.typography.fontFamily,
        borderRadius: `${theme.shape.borderRadius}px`,

        // See all possible variables below
      },
      rules: {
        ".Input:focus": {
          borderColor: theme.palette.primary.main,
          boxShadow: "none",
        },
      },
    },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      {loading && <LinearProgress />}
      <StripeCheckout
        setError={setError}
        setLoading={setLoading}
        paymentData={paymentData}
        loading={loading}
        returnUrl={returnUrl}
        recurrentDescComponent={recurrentDescComponent}
        paymentHasError={paymentHasError}
        setPaymentHasError={setPaymentHasError}
      />
    </Elements>
  );
}

StripePaymentForm.propTypes = {
  paymentHasError: PropTypes.bool,
  setPaymentHasError: PropTypes.func.isRequired,
  paymentData: PropTypes.shape({
    clientSecret: PropTypes.string.isRequired,
    publishableKey: PropTypes.string.isRequired,
  }).isRequired,
  recurrentDescComponent: PropTypes.object,
  setError: PropTypes.func,
  returnUrl: PropTypes.string.isRequired,
};
